import { render, staticRenderFns } from "./general-info-tab.vue?vue&type=template&id=1aeb7eea&scoped=true"
import script from "./general-info-tab.vue?vue&type=script&lang=js"
export * from "./general-info-tab.vue?vue&type=script&lang=js"
import style0 from "./general-info-tab.vue?vue&type=style&index=0&id=1aeb7eea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aeb7eea",
  null
  
)

export default component.exports